import { render, staticRenderFns } from "./Intelligence.vue?vue&type=template&id=448be0b8&scoped=true&"
import script from "./Intelligence.vue?vue&type=script&lang=js&"
export * from "./Intelligence.vue?vue&type=script&lang=js&"
import style0 from "./Intelligence.vue?vue&type=style&index=0&id=448be0b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448be0b8",
  null
  
)

export default component.exports